import AsyncCKEditorLoader from './AsyncCKEditorLoader';

export default {
  create(editorDiv: any, configurator: any) {
    return new AsyncCKEditorLoader(editorDiv, configurator);
  },
};
